import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Checkbox,
  Input,
  MultiSelect,
} from '@roger/ui-components';
import { SURROUNDING_TISSUE_OPTIONS } from '../../../constants/wounds';
import type { SurroundingTissueState } from '../assessmentFormTypes';

interface SurroundingTissueSectionProps {
  state: SurroundingTissueState;
  onChange: (update: Partial<SurroundingTissueState>) => void;
}

const SurroundingTissueSection: React.FC<SurroundingTissueSectionProps> = ({
  state,
  onChange,
}) => (
  <AccordionItem value='surrounding_tissue' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Surrounding Tissue
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      <div className='flex items-center gap-2'>
        <Checkbox
          id='st-na'
          checked={state.notAssessed}
          onCheckedChange={v =>
            onChange({ notAssessed: !!v, ...(!v && { notAssessedReason: '' }) })
          }
        />
        <label htmlFor='st-na' className='text-sm cursor-pointer'>
          Not Assessed
        </label>
      </div>
      {state.notAssessed && (
        <Input
          placeholder='Reason not assessed...'
          value={state.notAssessedReason}
          onChange={e => onChange({ notAssessedReason: e.target.value })}
          inputSize='sm'
        />
      )}
      {!state.notAssessed && (
        <div className='space-y-2'>
          <MultiSelect
            options={SURROUNDING_TISSUE_OPTIONS}
            value={state.values}
            onChange={v =>
              onChange({
                values: v,
                ...(!v.includes('other') && { otherText: '' }),
              })
            }
          />
          {state.values.includes('other') && (
            <Input
              placeholder='Describe other tissue...'
              value={state.otherText}
              onChange={e => onChange({ otherText: e.target.value })}
              inputSize='sm'
            />
          )}
        </div>
      )}
    </AccordionContent>
  </AccordionItem>
);

export default SurroundingTissueSection;
